import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Tabs,
  Tab,
} from '@material-ui/core';
import {
  getEventSubscription,
  updateEventSubscription,
} from '@pingum/app-state-management/eventSubscription/actions';
import { getTags } from '@pingum/app-state-management/tag/actions';
import { getTagTypes } from '@pingum/app-state-management/tagType/actions';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import DashboardSubscriptionsCard from './DashboardSubscriptionsCard';
import EventTemplateSubscriptionsCard from './EventTemplateSubscriptionsCard';
import Page from '../../widgets/Page';

export class UserSubscriptionsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { selectedTab: 0 };

    this.props.getEventSubscription(this.props.profile.user_id);
    this.props.getStatuses();
    this.props.getTags();
    this.props.getTagTypes();
  }

  handleChangeTab = (event, value) => {
    this.setState({ selectedTab: value });
  }

  render() {
    const {
      isFetching,
      hidePageContent,
    } = this.props;

    const tabs = (
      <Tabs
        value={this.state.selectedTab}
        onChange={this.handleChangeTab}
        indicatorColor="secondary"
        textColor="inherit"
      >
        <Tab label="Dashboards" />
        <Tab label="Workflows" />
      </Tabs>
    );
    const content = (
      <div>
        {
          this.state.selectedTab === 0
          && (
            <DashboardSubscriptionsCard
              updateEventSubscription={this.props.updateEventSubscription}
            />
          )
        }
        {
          this.state.selectedTab === 1
            && (
              <EventTemplateSubscriptionsCard
                updateEventSubscription={this.props.updateEventSubscription}
              />
            )
        }
      </div>
    );
    return (
      !hidePageContent
        ? (
          <Page
            title="My Subscriptions"
            toolbar={tabs}
            disableToolbarGutters
            showLoadingIndicator={isFetching}
          >
            {content}
          </Page>
        )
        : (
          <div>
            {tabs}
            {content}
          </div>
        )
    );
  }
}

UserSubscriptionsComponent.propTypes = {
  hidePageContent: PropTypes.bool,
  profile: PropTypes.object,
  updateEventSubscription: PropTypes.func,
  getEventSubscription: PropTypes.func,
  getTags: PropTypes.func,
  getTagTypes: PropTypes.func,
  getStatuses: PropTypes.func,
  isFetching: PropTypes.bool,
};

UserSubscriptionsComponent.defaultProps = {
  hidePageContent: false,
  profile: { user_id: '' },
  getEventSubscription: () => {},
  updateEventSubscription: () => {},
  getStatuses: () => {},
  getTags: () => {},
  getTagTypes: () => {},
  isFetching: false,
};

export const mapDispatchToProps = (dispatch) => ({
  getEventSubscription: (auth0UserId) => dispatch(getEventSubscription(auth0UserId)),
  updateEventSubscription: (auth0UserId, request) => dispatch(updateEventSubscription(auth0UserId, request)),
  getStatuses: () => dispatch(getStatuses(false)),
  getTags: () => dispatch(getTags(false, false)),
  getTagTypes: () => dispatch(getTagTypes(false, false)),
});

export const mapStateToProps = (state) => ({
  profile: state.user.user,
  isFetching:
    state.dashboard.isFetchingDashboards
    || state.eventSubscription.isFetchingEventSubscription,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserSubscriptionsComponent);

